function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "14",
  viewBox: "0 0 23 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  width: "21",
  height: "13.44",
  rx: "2",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 .84l10.889 6.72L22 .84",
  stroke: "#F6335D",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));